import React from 'react';

const Controls = props => {
  const {
    foregroundColor,
    setForegroundColor,
    backgroundColor,
    setBackgroundColor,
    strokeColor,
    setStrokeColor,
    strokeWidth,
    setStrokeWidth,
  } = props;

  const onForegroundColorChange = event => {
    const newValue = event.target.value;
    setForegroundColor(newValue);
    document
      .querySelectorAll('.icon-foreground')
      .forEach(icon => icon.setAttribute('fill', newValue));
  };

  const onBackgroundColorChange = event => {
    const newValue = event.target.value;
    setBackgroundColor(newValue);
    document
      .querySelectorAll('.icon-background')
      .forEach(icon => icon.setAttribute('fill', newValue));
  };

  const onStrokeColorChange = event => {
    const newValue = event.target.value;
    setStrokeColor(newValue);
    document
      .querySelectorAll('.icon-wrapper')
      .forEach(icon => icon.setAttribute('stroke', newValue));
  };

  const onStrokeWidthChange = event => {
    const newValue = event.target.value;
    setStrokeWidth(newValue);
    document
      .querySelectorAll('.icon-wrapper')
      .forEach(icon => icon.setAttribute('stroke-width', newValue));
  };

  return (
    <div>
      Foreground colour
      <input
        type="color"
        value={foregroundColor}
        onChange={onForegroundColorChange}
      />
      Background colour
      <input
        type="color"
        value={backgroundColor}
        onChange={onBackgroundColorChange}
      />
      Stroke colour
      <input type="color" value={strokeColor} onChange={onStrokeColorChange} />
      Stroke width
      <input
        type="number"
        min="0"
        max="20"
        value={strokeWidth}
        onChange={onStrokeWidthChange}
      />
    </div>
  );
};

Controls.propTypes = {};

export default Controls;
